import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PASS_RAW_ERROR } from './http-error.context';

@Injectable()
export class ApiForbiddenInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 403) {
        this.snackBar.open('У доступі до ресурсу відмовлено. Зверніться до керівника.', 'ok', {});
      }

      if (request.context.get(PASS_RAW_ERROR)) {
        return throwError(() => err);
      }

      const error = err.error?.message || err.statusText;
      return throwError(() => error);
    }));

  }
}
